// FNP-724: detect the billing-api CUSTOMER_NOT_LINKED error.
//
// FNP-718 made the 4 billing mutation/setup ops (enable/disable-BillingProviderForCurrentCustomer,
// payment-profile-setups initialize/confirm) throw a TYPED `CUSTOMER_NOT_LINKED` error (message
// "Customer ID not found in token") — instead of a raw UNAUTHORIZED — for the brief window after
// signup+link before the customerId token claim refreshes (which FNP-724's forced refresh now
// shortens to seconds). The portal should render this as a friendly "billing profile is still
// setting up" state, not a raw red error toast.
//
// Amplify v6 surfaces GraphQL errors on the thrown Error's `errors[]` array, each with `errorType`
// and `message` (see reference_amplify_error_identity). We match on the errorType (canonical) and
// fall back to the message text for resilience.

export const CUSTOMER_NOT_LINKED = 'CUSTOMER_NOT_LINKED';

type GraphQLErrorLike = { errorType?: string; message?: string };

export const isCustomerNotLinkedError = (e: unknown): boolean => {
    const errors = (e as { errors?: GraphQLErrorLike[] })?.errors;
    if (Array.isArray(errors)) {
        return errors.some(
            (err) =>
                err?.errorType === CUSTOMER_NOT_LINKED ||
                err?.message === 'Customer ID not found in token',
        );
    }
    // Some call paths re-wrap the error; also check a top-level message/errorType.
    const top = e as GraphQLErrorLike;
    return top?.errorType === CUSTOMER_NOT_LINKED || top?.message === 'Customer ID not found in token';
};

// The user-facing copy for the not-yet-linked window.
export const CUSTOMER_NOT_LINKED_MESSAGE =
    'Your billing profile is still being set up. Please try again in a moment.';
